import {
  McleodCommodityOption,
  McleodReferenceNumberOption,
  ValueLabelOption,
} from 'pages/QuoteView/LoadBuilding/McleodSectionForms/types';

// PT Brokers' McLeod lookup lists, generated from the backend's PT tenant data
// (drumkit common/integrations/tms/mcleodenterprise/enums_pt_data.go), which was read from PT's McLeod
// web order entry on 2026-10-29. Regenerate from that file rather than editing by hand.

export const ptTransportTypeOptions: ValueLabelOption[] = [
  { value: 'AU', label: 'AU - Auger' },
  { value: 'AC', label: 'AC - Auto Carrier (DAT)' },
  { value: 'BDUM', label: 'BDUM - Belly Dump' },
  { value: 'CV', label: 'CV - Belt' },
  { value: 'CN', label: 'CN - Conestoga (DAT)' },
  { value: 'C', label: 'C - Container (DAT)' },
  { value: 'DD', label: 'DD - Double Drop (DAT)' },
  { value: 'LA', label: 'LA - Double Drop Trailers' },
  { value: 'DDT', label: 'DDT - Drop Deck Trailers' },
  { value: 'DT', label: 'DT - End Dump' },
  { value: 'F', label: 'F - Flatbed (DAT)' },
  { value: 'FH', label: 'FH - Flatbed Hotshot (DAT)' },
  { value: 'FD', label: 'FD - Flatbed or Step Deck (DAT)' },
  { value: 'FM', label: 'FM - Flatbed w/ Team (DAT)' },
  { value: 'LOG', label: 'LOG - Forestry Trailers' },
  { value: 'FO', label: 'FO - Heavy Haul Trailers' },
  { value: 'HB', label: 'HB - Hopper Bottom (DAT)' },
  { value: 'HHS', label: 'HHS - Hopper High Side' },
  { value: 'VA', label: 'VA - Intermodal Trailers' },
  { value: 'LD', label: 'LD - Landoll' },
  { value: 'LVB', label: 'LVB - Live Bottom' },
  { value: 'LB', label: 'LB - Lowboy (DAT)' },
  { value: 'LR', label: 'LR - Lowboy or Rgn (DAT)' },
  { value: 'LTL', label: 'LTL - Misc Less-Than-Truckload' },
  { value: 'NU', label: 'NU - Pneumatic (DAT)' },
  { value: 'PO', label: 'PO - Power Only (DAT)' },
  { value: 'R', label: 'R - Reefer (DAT)' },
  { value: 'RM', label: 'RM - Reefer w/ Team (DAT)' },
  { value: 'OT', label: 'OT - Refuse Transfer Trailers' },
  { value: 'RG', label: 'RG - Removable GooseNeck (DAT)' },
  { value: 'SDUM', label: 'SDUM - Side Dump' },
  { value: 'SPV', label: 'SPV - Sprinter Van' },
  { value: 'SD', label: 'SD - Step Deck (DAT)' },
  { value: 'SG', label: 'SG - Stinger' },
  { value: 'SB', label: 'SB - Straight Box Truck' },
  { value: 'SBT', label: 'SBT - Straight Box Trucks' },
  { value: 'STFL', label: 'STFL - STRETCH FLAT' },
  { value: 'CTAN', label: 'CTAN - Tanker, Chemical' },
  { value: 'FGTK', label: 'FGTK - Tanker, FG' },
  { value: 'KTAN', label: 'KTAN - Tanker, Kosher' },
  { value: 'NFGT', label: 'NFGT - Tanker, Non-Fg' },
  { value: 'TA', label: 'TA - Tanker, Not Specified' },
  { value: '3A', label: '3A - Tri-Axle Dump Truck' },
  { value: 'TT', label: 'TT - Truck Tractors' },
  { value: 'V', label: 'V - Van (DAT)' },
  { value: 'VG', label: 'VG - Van Lift-Gate (DAT)' },
  { value: 'VR', label: 'VR - Van or Reefer (DAT)' },
  { value: 'VV', label: 'VV - Van Vented (DAT)' },
  { value: 'VM', label: 'VM - Van w/ Team (DAT)' },
  { value: 'VAR', label: 'VAR - Van, Air-Ride' },
  { value: 'WF', label: 'WF - Walking Floor' },
  { value: 'WATE', label: 'WATE - Water Hauling' },
];

// ADMIN and TRAIN are left out: reps don't build customer loads under them (60 TRAIN and 3 ADMIN of
// 23,886 synced PT loads).
export const ptRevenueCodes: ValueLabelOption[] = [
  { value: 'AR', label: 'AR - Anthony' },
  { value: 'BM', label: 'BM - Barry/Jessica' },
  { value: 'BS', label: 'BS - BEN SIEGEL' },
  { value: 'CG', label: 'CG - CALVIN GREEN' },
  { value: 'CM', label: 'CM - Christian' },
  { value: 'CR', label: 'CR - Chanda' },
  { value: 'EM', label: 'EM - Erica' },
  { value: 'EM01', label: 'EM01 - Maddy' },
  { value: 'EW', label: 'EW - Errol' },
  { value: 'FLAT1', label: 'FLAT1 - FLATBED' },
  { value: 'IA', label: 'IA - Katelyn' },
  { value: 'JH', label: 'JH - Joe' },
  { value: 'JP', label: 'JP - Jonathan Post' },
  { value: 'KC', label: 'KC - Shirley' },
  { value: 'KH', label: 'KH - Kreli' },
  { value: 'LB', label: 'LB - Charlie/Joyce' },
  { value: 'MST01', label: 'MST01 - MS TEAM 1' },
  { value: 'MST02', label: 'MST02 - MS TEAM 2' },
  { value: 'MST03', label: 'MST03 - MS TEAM 3' },
  { value: 'MST04', label: 'MST04 - MS TEAM 4' },
  { value: 'NAS01', label: 'NAS01 - NASHVILLE BULK1' },
  { value: 'NAS02', label: 'NAS02 - NASHVILLE BULK2' },
  { value: 'NAS03', label: 'NAS03 - NASHVILLE VAN' },
  { value: 'NAS04', label: 'NAS04 - DREW WAGGONER' },
  { value: 'NE', label: 'NE - Sparky' },
  { value: 'PB', label: 'PB - PB' },
  { value: 'RO', label: 'RO - ROBBIE OWENS' },
  { value: 'SC', label: 'SC - MARLENE DOAR' },
  { value: 'TP', label: 'TP - Todd' },
  { value: 'VAN01', label: 'VAN01 - CALEB' },
  { value: 'VAN02', label: 'VAN02 - MATT' },
  { value: 'VAN03', label: 'VAN03 - Chance' },
  { value: 'VAN04', label: 'VAN04 - ZACH' },
  { value: 'VAN05', label: 'VAN05 - KWESTGARD' },
  { value: 'ZA', label: 'ZA - ZAC ANDERSON' },
  { value: 'ZF', label: 'ZF - ZF' },
];

export const ptOrderTypes: ValueLabelOption[] = [
  { value: 'DET', label: 'DET - Detention' },
  { value: 'DISPATCH', label: 'DISPATCH - Ready to Dispatch' },
  { value: 'RICE', label: 'RICE - Rice' },
  { value: 'SPLIT', label: 'SPLIT - Split' },
  { value: 'TEST1WAY', label: 'TEST1WAY - Test Load' },
];

export const ptCommodityOptions: McleodCommodityOption[] = [
  { code: '#11CRUSHE', description: '#11 CRUSHED GRAVEL', hazmat: 'N', un: '' },
  { code: '#16CRUGRA', description: '#16 CRUSHED GRAVEL', hazmat: 'N', un: '' },
  {
    code: '#1CNAUBLE',
    description: '#1 CONCRETE AUTUMN BLEND',
    hazmat: 'N',
    un: '',
  },
  { code: '#1MOJAVE', description: '#1 MOJAVE BLEND', hazmat: 'N', un: '' },
  { code: '#2MOJAVE', description: '#2 MOJAVE BLEND', hazmat: 'N', un: '' },
  { code: '#2SLACHIP', description: '#2 SLATE CHIPS', hazmat: 'N', un: '' },
  { code: '#4DAPPLE', description: '#4 DAPPLE BLEND', hazmat: 'N', un: '' },
  { code: '#4PINGRAN', description: '#4 PINK GRANITE', hazmat: 'N', un: '' },
  {
    code: '#57CRANBE',
    description: '#57 CRANBERRY GRANITE',
    hazmat: 'N',
    un: '',
  },
  { code: '#57MAYBLA', description: '#57 MAYLEN BLACK', hazmat: 'N', un: '' },
  { code: '#57MOJAVE', description: '#57 MOJAVE BLEND', hazmat: 'N', un: '' },
  {
    code: '#5AZTBRCH',
    description: '#5 AZTEC BROWN CHESTNUT BLEND',
    hazmat: 'N',
    un: '',
  },
  {
    code: '#5CHARGRA',
    description: '#5 CHARCOAL GRANITE',
    hazmat: 'N',
    un: '',
  },
  { code: '#5MAYLEN', description: '#5 MAYLEN BLACK', hazmat: 'N', un: '' },
  {
    code: '#5SALTPEP',
    description: '#5 SALT & PEPPER GRANITE',
    hazmat: 'N',
    un: '',
  },
  { code: '#5SLATECH', description: '#5 SLATE CHIPS', hazmat: 'N', un: '' },
  { code: '#5STRGRAN', description: '#5 STRIPED GRANITE', hazmat: 'N', un: '' },
  { code: '0112HEAD', description: '0112 HEADLAP', hazmat: 'N', un: '' },
  { code: '1.5TRAPRO', description: '1.5 TRAP ROCK', hazmat: 'N', un: '' },
  { code: '112H', description: '112H', hazmat: 'N', un: '' },
  { code: '11GRAN', description: '11 GRANULAR', hazmat: 'N', un: '' },
  { code: '21-0-21', description: '21-0-21', hazmat: 'N', un: '' },
  { code: '21MONOCAL', description: '21% MONOCAL', hazmat: 'N', un: '' },
  { code: '2200', description: '2200 GRANULAR', hazmat: 'N', un: '' },
  {
    code: '2700ROOF',
    description: '2700 ROOFING GRANULES',
    hazmat: 'N',
    un: '',
  },
  { code: '3/4TRAPRK', description: '3/4 TRAP ROCK', hazmat: 'N', un: '' },
  { code: '3700GRAN', description: '3700 GRANULAR', hazmat: 'N', un: '' },
  { code: '4100GRANU', description: '4100 GRANULAR', hazmat: 'N', un: '' },
  {
    code: '4600ROOF',
    description: '4600 ROOFING GRANULAR',
    hazmat: 'N',
    un: '',
  },
  { code: '5100GRANU', description: '5100 GRANULARS', hazmat: 'N', un: '' },
  {
    code: '5300ROOF',
    description: '5300 ROOFING GRANULES',
    hazmat: 'N',
    un: '',
  },
  { code: '5500', description: '5500 ROOFING GRANULARS', hazmat: 'N', un: '' },
  { code: '60GLUTENM', description: '60% GLUTEN MEAL', hazmat: 'N', un: '' },
  {
    code: '6500ROOF',
    description: '6500 ROOFING GRANULES',
    hazmat: 'N',
    un: '',
  },
  { code: '6800GRANU', description: '6800 GRANULARS', hazmat: 'N', un: '' },
  {
    code: '7000ROOF',
    description: '7000 ROOFING GRANULES',
    hazmat: 'N',
    un: '',
  },
  { code: '7100GRANU', description: '7100 GRANULARS', hazmat: 'N', un: '' },
  {
    code: '7600ROOF',
    description: '760 ROOFING GRANULARS',
    hazmat: 'N',
    un: '',
  },
  {
    code: '7600ROOFI',
    description: '7600 ROOFING GRANULES',
    hazmat: 'N',
    un: '',
  },
  { code: '7700GRAN', description: '7700 GRANULAR', hazmat: 'N', un: '' },
  {
    code: '7800ROOF',
    description: '7800 ROOFING GRANULES',
    hazmat: 'N',
    un: '',
  },
  {
    code: '9300ROOF',
    description: '9300 ROOFING GRANULES',
    hazmat: 'N',
    un: '',
  },
  { code: '98G', description: '98 G', hazmat: 'N', un: '' },
  { code: 'AB', description: 'AB', hazmat: 'N', un: '' },
  {
    code: 'ACPARTS',
    description: 'AIR CONDITIONER PARTS',
    hazmat: 'N',
    un: '',
  },
  { code: 'ADHES', description: 'ADHESIVE', hazmat: 'N', un: '' },
  { code: 'AGFINES', description: 'AG FINES', hazmat: 'N', un: '' },
  { code: 'AGGREGATE', description: 'AGGREGATE', hazmat: 'N', un: '' },
  { code: 'AGSORB', description: 'AGSORB', hazmat: 'N', un: '' },
  {
    code: 'ALASUNPEA',
    description: 'AL SUNSET PEA GRAVEL 1/2"',
    hazmat: 'N',
    un: '',
  },
  { code: 'ALFALFAME', description: 'ALFALFA MEAL', hazmat: 'N', un: '' },
  { code: 'ALFALFAPE', description: 'ALFALFA PELLETS', hazmat: 'N', un: '' },
  { code: 'ALMONDHUL', description: 'ALMOND HULLS', hazmat: 'N', un: '' },
  {
    code: 'ALSUNLAND',
    description: 'ALABAMA SUNSET LANDSCAPE',
    hazmat: 'N',
    un: '',
  },
  { code: 'ALUMINUM', description: 'Aluminum', hazmat: 'N', un: '' },
  { code: 'AMERIBOND', description: 'AMERI-BOND', hazmat: 'N', un: '' },
  { code: 'AMIDAS', description: 'AMIDAS', hazmat: 'N', un: '' },
  { code: 'AMINO', description: 'AMINO PLUS', hazmat: 'N', un: '' },
  { code: 'AMMONIUM', description: 'AMMONIUM SULFATE', hazmat: 'N', un: '' },
  { code: 'AMPLIFY', description: 'AMPLIFY', hazmat: 'N', un: '' },
  { code: 'AMS', description: 'AMS', hazmat: 'N', un: '' },
  { code: 'ANIMATE', description: 'ANIMATE', hazmat: 'N', un: '' },
  { code: 'AP53', description: 'AP53/PROGAIN', hazmat: 'N', un: '' },
  { code: 'APPLES', description: 'APPLES', hazmat: 'N', un: '' },
  { code: 'ASPHALT', description: 'ASPHALT', hazmat: 'N', un: '' },
  {
    code: 'ASTM#57',
    description: 'ASTM #57 MULTI COLOR; CODE 7370',
    hazmat: 'N',
    un: '',
  },
  { code: 'ATTACH', description: 'ATTACHMENTS', hazmat: 'N', un: '' },
  { code: 'AUTOPARTS', description: 'AUTO PARTS', hazmat: 'N', un: '' },
  { code: 'AZOMITE', description: 'AZOMITE', hazmat: 'N', un: '' },
  { code: 'BACON', description: 'BACON', hazmat: 'N', un: '' },
  { code: 'BAGSWP', description: 'BAGS - WOVEN, POLY', hazmat: 'N', un: '' },
  { code: 'BAKERYMEA', description: 'BAKERY MEAL', hazmat: 'N', un: '' },
  {
    code: 'BAMAPREM',
    description: 'BAMA PREMIUM USGA BUNKER SAND- PRODUCT 104',
    hazmat: 'N',
    un: '',
  },
  { code: 'BARIUMSUL', description: 'BARIUM SULFATE', hazmat: 'N', un: '' },
  { code: 'BARLEY', description: 'BARLEY', hazmat: 'N', un: '' },
  { code: 'BAUXITE', description: 'BAUXITE', hazmat: 'N', un: '' },
  { code: 'BEAMS', description: 'BEAMS', hazmat: 'N', un: '' },
  { code: 'BEANS', description: 'BEANS', hazmat: 'N', un: '' },
  { code: 'BEDDING', description: 'BEDDING FOAM', hazmat: 'N', un: '' },
  { code: 'BEEF', description: 'BEEF', hazmat: 'N', un: '' },
  { code: 'BEEFBONE', description: 'BEEF AND BONE', hazmat: 'N', un: '' },
  { code: 'BEEFFEED', description: 'BEEF FEED', hazmat: 'N', un: '' },
  { code: 'BEEFMEAT', description: 'BEEF MEAT & BONE', hazmat: 'N', un: '' },
  { code: 'BEEFMEATM', description: 'BEEF MEAT MEAL', hazmat: 'N', un: '' },
  { code: 'BEEFSLURR', description: 'BEEF SLURRY', hazmat: 'N', un: '' },
  { code: 'BEEFTAL', description: 'TALLOW, BEEF', hazmat: 'N', un: '' },
  {
    code: 'BEEFTOTE',
    description: 'Beef Bone Broth, Dried, Tote',
    hazmat: 'N',
    un: '',
  },
  { code: 'BEETPULP', description: 'BEET PULP SHREDS', hazmat: 'N', un: '' },
  { code: 'BEETPULPE', description: 'BEET PULP PELLETS', hazmat: 'N', un: '' },
  { code: 'BIO', description: 'BIO SOLIDS', hazmat: 'N', un: '' },
  { code: 'BIOCHAR', description: 'BIOCHAR', hazmat: 'N', un: '' },
  { code: 'BIODAC', description: 'BIODAC 12/20 (JDL)', hazmat: 'N', un: '' },
  { code: 'BIODACT', description: 'BIODACT 8/16', hazmat: 'N', un: '' },
  { code: 'BIOFOS', description: 'BIO FOS', hazmat: 'N', un: '' },
  { code: 'BIOPHOS', description: 'BIO-PHOS', hazmat: 'N', un: '' },
  { code: 'BLACKBEAU', description: 'BLACK BEAUTY', hazmat: 'N', un: '' },
  {
    code: 'BLACKOIL',
    description: 'BLACK OIL SUNFLOWERS',
    hazmat: 'N',
    un: '',
  },
  { code: 'BLASTSAND', description: 'BLASTING SAND', hazmat: 'N', un: '' },
  { code: 'BLENDFEED', description: 'BLENDED FEED', hazmat: 'N', un: '' },
  {
    code: 'BLKCHERTR',
    description: 'BLACK CHEROKEE TRAP 1 1/2" CODE: CLEAN AT1120C',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BLKCHTR34',
    description: 'BLACK CHEROKEE TRAP 3/4" PRODUCT CODE 280: CLEAN AT3400C 3/4',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BLKMIDLAV',
    description: 'BLACK MIDNIGHT LAVA',
    hazmat: 'N',
    un: '',
  },
  { code: 'BLKOBSIDI', description: 'BLACK OBSIDIAN', hazmat: 'N', un: '' },
  { code: 'BLOODMEAL', description: 'BLOOD MEAL', hazmat: 'N', un: '' },
  { code: 'BOATS', description: 'BOAT', hazmat: 'N', un: '' },
  { code: 'BOILER', description: 'Boiler', hazmat: 'N', un: '' },
  { code: 'BONEMEAL', description: 'Bone Meal', hazmat: 'N', un: '' },
  { code: 'BOOST', description: 'BOOST', hazmat: 'N', un: '' },
  { code: 'BORE', description: 'Bore', hazmat: 'N', un: '' },
  { code: 'BRAN', description: 'RICE BRAN', hazmat: 'N', un: '' },
  { code: 'BRASSFIC', description: 'BRASSFIELD C', hazmat: 'N', un: '' },
  { code: 'BRASSFIE', description: 'BRASSFIELD #11', hazmat: 'N', un: '' },
  { code: 'BRASSFIEL', description: 'BRASSFIELD #8', hazmat: 'N', un: '' },
  {
    code: 'BRASSFINE',
    description: 'BRASSFIELD FINES #12',
    hazmat: 'N',
    un: '',
  },
  { code: 'BREWERSR', description: 'BREWERS RICE', hazmat: 'N', un: '' },
  { code: 'BRICK', description: 'BRICK', hazmat: 'N', un: '' },
  { code: 'BRICKCHIP', description: 'BRICK CHIPS 1"', hazmat: 'N', un: '' },
  { code: 'BROWN', description: 'BROWN', hazmat: 'N', un: '' },
  { code: 'BROWNRICE', description: 'BROWN RICE', hazmat: 'N', un: '' },
  {
    code: 'BUGIMIRH',
    description: 'BULK GIANT MISCANTHUS RHIZOMES',
    hazmat: 'N',
    un: '',
  },
  { code: 'BUILDSUPP', description: 'BUILDING SUPPLIES', hazmat: 'N', un: '' },
  { code: 'BULK', description: 'BULK', hazmat: 'N', un: '' },
  {
    code: 'BURBLEND1',
    description: 'BURGUNDY BLEND 1.5X3/4" RED FLINT STANDARD',
    hazmat: 'N',
    un: '',
  },
  { code: 'BUSHELING', description: 'BUSHELING', hazmat: 'N', un: '' },
  { code: 'BYPASSFAT', description: 'BYPASS FAT 85%', hazmat: 'N', un: '' },
  {
    code: 'CALCAR102',
    description: 'Calcium Carbonate 102',
    hazmat: 'N',
    un: '',
  },
  { code: 'CALCARBON', description: 'CALCIUM CARBONATE', hazmat: 'N', un: '' },
  { code: 'CALCIUM', description: 'CALCIUM', hazmat: 'N', un: '' },
  { code: 'CALSULFAT', description: 'CALCIUM SULFATE', hazmat: 'N', un: '' },
  { code: 'CANMARBLE', description: 'CANADIAN MARBLE', hazmat: 'N', un: '' },
  { code: 'CANOLA', description: 'CANOLA MEAL', hazmat: 'N', un: '' },
  { code: 'CANOLASEE', description: 'CANOLA SEED', hazmat: 'N', un: '' },
  { code: 'CARROTSBU', description: 'CARROTS BULK', hazmat: 'N', un: '' },
  { code: 'CARROTSDD', description: 'CARROTS DEHY DICES', hazmat: 'N', un: '' },
  { code: 'CATFISHFO', description: 'CATFISH FOOD', hazmat: 'N', un: '' },
  { code: 'CATFISHME', description: 'CATFISH MEAL', hazmat: 'N', un: '' },
  { code: 'CATTLECUB', description: 'CATTLE CUBES, BULK', hazmat: 'N', un: '' },
  { code: 'CBM', description: 'CBM', hazmat: 'N', un: '' },
  { code: 'CBMNUTRO', description: 'CBM NUTROX', hazmat: 'N', un: '' },
  { code: 'CBP', description: 'CBP', hazmat: 'N', un: '' },
  { code: 'CBPM', description: 'CHICKEN BY-PRODUCT MEAL', hazmat: 'N', un: '' },
  { code: 'CBPNATURO', description: 'CBP NATUROX', hazmat: 'N', un: '' },
  { code: 'CBPPETOX', description: 'CBP-PETOX', hazmat: 'N', un: '' },
  {
    code: 'CEDMUL100',
    description: 'CEDAR MULCH 100 YARDS',
    hazmat: 'N',
    un: '',
  },
  { code: 'CELLULOSE', description: 'CELLULOSE', hazmat: 'N', un: '' },
  { code: 'CEMENTSUP', description: 'CEMENT SUPERSACKS', hazmat: 'N', un: '' },
  { code: 'CEMTILE', description: 'CEMENT TILES', hazmat: 'N', un: '' },
  { code: 'CEREAL', description: 'CEREAL FINES', hazmat: 'N', un: '' },
  { code: 'CEREALS', description: 'CEREAL', hazmat: 'N', un: '' },
  {
    code: 'CGFPELLET',
    description: 'CORN GLUTEN FEED PELLET',
    hazmat: 'N',
    un: '',
  },
  { code: 'CGP', description: 'CGP', hazmat: 'N', un: '' },
  {
    code: 'CHICBYPRO',
    description: 'CHICKEN BY PRODUCTS',
    hazmat: 'N',
    un: '',
  },
  { code: 'CHICKENBO', description: 'CHICKEN BONE', hazmat: 'N', un: '' },
  { code: 'CHICKENBY', description: 'CHICKEN BY NATURAL', hazmat: 'N', un: '' },
  { code: 'CHICKENFA', description: 'CHICKEN FAT', hazmat: 'N', un: '' },
  { code: 'CHICKENFE', description: 'CHICKEN FEATHERS', hazmat: 'N', un: '' },
  { code: 'CHICKENLI', description: 'CHICKEN LITTER', hazmat: 'N', un: '' },
  {
    code: 'CHICKENMA',
    description: 'CHICKEN MANURE PELLETS',
    hazmat: 'N',
    un: '',
  },
  { code: 'CHICKENMD', description: 'CHICKEN MDM', hazmat: 'N', un: '' },
  { code: 'CHICKENME', description: 'CHICKEN MEAL', hazmat: 'N', un: '' },
  { code: 'CHICKENOF', description: 'CHICKEN OFFAL', hazmat: 'N', un: '' },
  {
    code: 'CHICKENPE',
    description: 'CHICKEN MEAL / PETOX',
    hazmat: 'N',
    un: '',
  },
  { code: 'CHICKENSL', description: 'CHICKEN SLUDGE', hazmat: 'N', un: '' },
  { code: 'CHICKPEAS', description: 'CHICK PEAS', hazmat: 'N', un: '' },
  {
    code: 'CHIMIXFEE',
    description: 'CHICKEN MIXED FEED PELLETS',
    hazmat: 'N',
    un: '',
  },
  { code: 'CHIP', description: 'CHIP SEAL', hazmat: 'N', un: '' },
  { code: 'CHKNFROZ', description: 'CHICKEN, FROZEN', hazmat: 'N', un: '' },
  { code: 'CHOCOLATE', description: 'CHOCOLATE MEAL', hazmat: 'N', un: '' },
  {
    code: 'CINNAMON',
    description: 'CINNAMON 5/16X5/8 "50 PEA GRAVEL',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CINNMED',
    description: 'CINNAMON MEDIUM (SMALL)',
    hazmat: 'N',
    un: '',
  },
  { code: 'CITRUS', description: 'CITRUS', hazmat: 'N', un: '' },
  { code: 'CITRUSPEL', description: 'CITRUS PELLETS', hazmat: 'N', un: '' },
  {
    code: 'CITRUSPUL',
    description: 'CITRUS PULP PELLETS',
    hazmat: 'N',
    un: '',
  },
  { code: 'CLAY', description: 'CLAY', hazmat: 'N', un: '' },
  { code: 'CLEANRICE', description: 'CLEAN RICE', hazmat: 'N', un: '' },
  { code: 'CMNTX', description: 'CM-NTX', hazmat: 'N', un: '' },
  { code: 'COABRAFEE', description: 'COARSE BRAN FEED', hazmat: 'N', un: '' },
  { code: 'COARSEMON', description: 'COARSE MONOCAL', hazmat: 'N', un: '' },
  { code: 'COIL', description: 'COILS', hazmat: 'N', un: '' },
  { code: 'COMPOST', description: 'COMPOST', hazmat: 'N', un: '' },
  { code: 'CONDUIT', description: 'CONDUIT', hazmat: 'N', un: '' },
  { code: 'COOKIEMEA', description: 'COOKIE MEAL', hazmat: 'N', un: '' },
  { code: 'COPPERSLA', description: 'COPPER SLAG', hazmat: 'N', un: '' },
  { code: 'CORN', description: 'CORN', hazmat: 'N', un: '' },
  { code: 'CORNBRAN', description: 'CORN BRAN', hazmat: 'N', un: '' },
  { code: 'CORNDG', description: 'Corn Distillers Grain', hazmat: 'N', un: '' },
  { code: 'CORNGERM', description: 'CORN GERM', hazmat: 'N', un: '' },
  { code: 'CORNGERMM', description: 'CORN GERM MEAL', hazmat: 'N', un: '' },
  { code: 'CORNGLUFE', description: 'CORN GLUTEN FEED', hazmat: 'N', un: '' },
  {
    code: 'CORNGLUPE',
    description: 'CORN GLUTEN PELLETS',
    hazmat: 'N',
    un: '',
  },
  { code: 'CORNGLUTE', description: 'CORN GLUTEN MEAL', hazmat: 'N', un: '' },
  { code: 'CORNGRITS', description: 'CORN GRITS', hazmat: 'N', un: '' },
  { code: 'CORNMEAL', description: 'CORN MEAL', hazmat: 'N', un: '' },
  { code: 'CORNOIL', description: 'CORN OIL, LIQUID', hazmat: 'N', un: '' },
  { code: 'CORNSCREE', description: 'CORN SCREENINGS', hazmat: 'N', un: '' },
  { code: 'CORNSTRCH', description: 'CORN STARCH', hazmat: 'N', un: '' },
  { code: 'CORNSYRUP', description: 'LIQUID CORN SYRUP', hazmat: 'N', un: '' },
  { code: 'COTSEED', description: 'COTTON SEED', hazmat: 'N', un: '' },
  { code: 'COTSEEDHU', description: 'COTTON SEED HULLS', hazmat: 'N', un: '' },
  { code: 'COTTONPEL', description: 'COTTONSEED PELLET', hazmat: 'N', un: '' },
  { code: 'COTTONSEE', description: 'COTTONSEED MEAL', hazmat: 'N', un: '' },
  { code: 'CPM', description: 'CORN PROTEIN MEAL', hazmat: 'N', un: '' },
  { code: 'CRACKCORN', description: 'CRACKED CORN', hazmat: 'N', un: '' },
  { code: 'CRATES', description: 'CRATES', hazmat: 'N', un: '' },
  { code: 'CRAX', description: 'CRAX', hazmat: 'N', un: '' },
  { code: 'CRUNCHGRA', description: 'CRUNCH GRAIN PMP', hazmat: 'N', un: '' },
  { code: 'CUBEDANIM', description: 'CUBED ANIMAL FEED', hazmat: 'N', un: '' },
  { code: 'CUCUMBERS', description: 'CUCUMBERS', hazmat: 'N', un: '' },
  { code: 'CULLET', description: 'CULLET', hazmat: 'N', un: '' },
  { code: 'CYPMULCH', description: 'CYPRESS MULCH', hazmat: 'N', un: '' },
  { code: 'DAIRYFEED', description: 'DAIRY FEED', hazmat: 'N', un: '' },
  { code: 'DAP', description: 'DAP', hazmat: 'N', un: '' },
  { code: 'DARPRO', description: 'DARPRO 58', hazmat: 'N', un: '' },
  {
    code: 'DAYRATEUN',
    description: 'Day Rate Underground Work',
    hazmat: 'N',
    un: '',
  },
  { code: 'DDG', description: 'DDG', hazmat: 'N', un: '' },
  { code: 'DDGCUBES', description: 'DDG CUBES', hazmat: 'N', un: '' },
  { code: 'DEFATBRAN', description: 'DEFAT BRAN', hazmat: 'N', un: '' },
  { code: 'DEGERCORN', description: 'DEGERMINATED CORN', hazmat: 'N', un: '' },
  {
    code: 'DESERTSUN',
    description: 'DESERT SUNSET R01-1160',
    hazmat: 'N',
    un: '',
  },
  { code: 'DG145', description: 'DG-145', hazmat: 'N', un: '' },
  { code: 'DGLITE', description: 'DGLITE', hazmat: 'N', un: '' },
  { code: 'DICAL', description: 'DICAL', hazmat: 'N', un: '' },
  { code: 'DIRT', description: 'DIRT', hazmat: 'N', un: '' },
  { code: 'DISTILGRA', description: 'DISTILLERS GRAIN', hazmat: 'N', un: '' },
  {
    code: 'DIXBLE1.5',
    description: 'DIXIE BLEND- SMALL 1.5',
    hazmat: 'N',
    un: '',
  },
  { code: 'DIXIEBLEN', description: 'DIXIE BLEND', hazmat: 'N', un: '' },
  { code: 'DOGFOOD', description: 'DOG FOOD', hazmat: 'N', un: '' },
  { code: 'DOLOMITE', description: 'DOLOMITE', hazmat: 'N', un: '' },
  { code: 'DRIED', description: 'DRIED POTATO', hazmat: 'N', un: '' },
  { code: 'DRIEDBLOO', description: 'DRIED BLOOD', hazmat: 'N', un: '' },
  {
    code: 'DRIMOLASS',
    description: 'DRIED BULK MOLASSES',
    hazmat: 'N',
    un: '',
  },
  { code: 'DRYFOODP', description: 'FOOD PRODUCT, DRY', hazmat: 'N', un: '' },
  { code: 'DRYMOL', description: 'DRY MOLASSES', hazmat: 'N', un: '' },
  { code: 'DURUM', description: 'DURUM', hazmat: 'N', un: '' },
  { code: 'DUST', description: 'DUST', hazmat: 'N', un: '' },
  { code: 'DYNAMATE', description: 'DYNAMATE', hazmat: 'N', un: '' },
  { code: 'EASYFLO', description: 'EASYFLO  COTTONSEED', hazmat: 'N', un: '' },
  { code: 'EASYFLOCO', description: 'EASYFLO COTTONSEED', hazmat: 'N', un: '' },
  { code: 'EDGE', description: 'EDGE', hazmat: 'N', un: '' },
  { code: 'EGG', description: 'EGG PRE MIX', hazmat: 'N', un: '' },
  { code: 'EGGNFLAVO', description: 'EGG N FLAVOR', hazmat: 'N', un: '' },
  { code: 'EMPOWER', description: 'EMPOWER', hazmat: 'N', un: '' },
  { code: 'EMPTY', description: 'EMPTY', hazmat: 'N', un: '' },
  { code: 'EMULSIFIE', description: 'EMULSIFIED SULFUR', hazmat: 'N', un: '' },
  { code: 'EMULSSULP', description: 'EMULSIFIED SULPHUR', hazmat: 'N', un: '' },
  { code: 'ENDENSE', description: 'ENDENSE', hazmat: 'N', un: '' },
  {
    code: 'ENEBOOBUL',
    description: 'ENERGY BOOSTER 100 BULK',
    hazmat: 'N',
    un: '',
  },
  { code: 'ENERGY2', description: 'ENERGY 2', hazmat: 'N', un: '' },
  { code: 'ENERGY3', description: 'ENERGY 3', hazmat: 'N', un: '' },
  { code: 'EQUIPMENT', description: 'EQUIPMENT', hazmat: 'N', un: '' },
  { code: 'ETIBOR', description: 'ETIBOR', hazmat: 'N', un: '' },
  { code: 'FAT', description: 'FAT', hazmat: 'N', un: '' },
  { code: 'FEATHERME', description: 'FEATHER MEAL', hazmat: 'N', un: '' },
  { code: 'FEED', description: 'FEED', hazmat: 'N', un: '' },
  { code: 'FEEDGRADE', description: 'FEED GRADE LIME', hazmat: 'N', un: '' },
  { code: 'FEEDGRURE', description: 'FEED GRADE UREA', hazmat: 'N', un: '' },
  { code: 'FEEDINGRE', description: 'FEED INGREDIENTS', hazmat: 'N', un: '' },
  { code: 'FEEDSALT', description: 'FEED SALT', hazmat: 'N', un: '' },
  { code: 'FELDSPATH', description: 'FELDSPATHIC SAND', hazmat: 'N', un: '' },
  { code: 'FERMENTEN', description: 'FERMENTEN', hazmat: 'N', un: '' },
  { code: 'FERTILIZE', description: 'FERTILIZER', hazmat: 'N', un: '' },
  { code: 'FIBER', description: 'FIBER', hazmat: 'N', un: '' },
  { code: 'FIBERPLAC', description: 'Fiber Placement', hazmat: 'N', un: '' },
  { code: 'FIELDFAIR', description: 'FIELD & FAIRWAY', hazmat: 'N', un: '' },
  { code: 'FINES', description: 'FINES', hazmat: 'N', un: '' },
  { code: 'FINGROCOR', description: 'FINE GROUND CORN', hazmat: 'N', un: '' },
  { code: 'FISH', description: 'FISH', hazmat: 'N', un: '' },
  { code: 'FISHFEEDP', description: 'FISH FEED PELLETS', hazmat: 'N', un: '' },
  { code: 'FISHMEAL', description: 'FISH MEAL', hazmat: 'N', un: '' },
  { code: 'FISHOIL', description: 'FISHOIL', hazmat: 'N', un: '' },
  { code: 'FLAX', description: 'FLAX SEED', hazmat: 'N', un: '' },
  { code: 'FLOUR', description: 'FLOUR', hazmat: 'N', un: '' },
  { code: 'FOODCOLR', description: 'FOOD COLORING', hazmat: 'N', un: '' },
  {
    code: 'FOODGRADE',
    description: 'FOOD GRADE SOYBEANS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FOODTEMP',
    description: 'Food Products, Temperature Controlled',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FOODVAN',
    description: 'Food Products, Non-Temperature Controlled',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FOOGRAYEL',
    description: 'FOOD GRADE YELLOW CORN',
    hazmat: 'N',
    un: '',
  },
  { code: 'FRACTANK', description: 'FRAC TANK', hazmat: 'N', un: '' },
  { code: 'FRACTIONS', description: 'FRACTIONS', hazmat: 'N', un: '' },
  { code: 'FRESHWATE', description: 'FRESH WATER', hazmat: 'N', un: '' },
  {
    code: 'FROROSEF',
    description: 'Frosted Rose #F Multi Color',
    hazmat: 'N',
    un: '',
  },
  { code: 'FROZENFOO', description: 'FROZEN FOOD', hazmat: 'N', un: '' },
  { code: 'FURNITURE', description: 'FURNITURE', hazmat: 'N', un: '' },
  {
    code: 'GAMARBLE',
    description: 'GEORGIA MARBLE 1 1/2"',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'GENFRT',
    description: 'GENERAL FREIGHT (Unspecified)',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'GLACBOULD',
    description: 'GLACIAL BOULDERS 15-20"',
    hazmat: 'N',
    un: '',
  },
  { code: 'GLUTEN', description: 'GLUTEN', hazmat: 'N', un: '' },
  { code: 'GLUTENFEE', description: 'GLUTEN FEED', hazmat: 'N', un: '' },
  { code: 'GLUTENPEL', description: 'GLUTEN PELLETS', hazmat: 'N', un: '' },
  { code: 'GLYCERINE', description: 'GLYCERINE', hazmat: 'N', un: '' },
  { code: 'GRADE5', description: 'GRADE 5', hazmat: 'N', un: '' },
  {
    code: 'GRAINSCRE',
    description: 'GRAIN SCREEN PELLETS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'GRANMICRO',
    description: 'GRAN MICROSYNC FUSION',
    hazmat: 'N',
    un: '',
  },
  { code: 'GRANSULF', description: 'GRANULAR SULFATE', hazmat: 'N', un: '' },
  { code: 'GRANULAR', description: 'GRANULAR', hazmat: 'N', un: '' },
  { code: 'GRANULAUR', description: 'GRANULAR UREA', hazmat: 'N', un: '' },
  { code: 'GRASSPELL', description: 'GRASS PELLETS', hazmat: 'N', un: '' },
  { code: 'GRAYSLATE', description: 'GRAY SLATE', hazmat: 'N', un: '' },
  { code: 'GRNDCORN', description: 'GROUND CORN', hazmat: 'N', un: '' },
  {
    code: 'GROUALMSH',
    description: 'GROUND ALMOND SHELLS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'GROUNDGRA',
    description: 'GROUND GRAPE POMACE',
    hazmat: 'N',
    un: '',
  },
  { code: 'GROUNDHUL', description: 'GROUND HULLS', hazmat: 'N', un: '' },
  { code: 'GROUNDRIC', description: 'GROUND RICE HULLS', hazmat: 'N', un: '' },
  { code: 'GYPSUM', description: 'GYPSUM', hazmat: 'N', un: '' },
  { code: 'HARDWHEAT', description: 'HARD WHEAT', hazmat: 'N', un: '' },
  {
    code: 'HARVESTBL',
    description: 'HARVEST BLEND GRAIN MIX BULK',
    hazmat: 'N',
    un: '',
  },
  { code: 'HC101', description: 'SAND LIKE CALCIUM', hazmat: 'N', un: '' },
  {
    code: 'HC102C',
    description: 'HI-CALCIUM COARSE HC102C',
    hazmat: 'N',
    un: '',
  },
  { code: 'HEADLAP', description: 'HEADLAP', hazmat: 'N', un: '' },
  { code: 'HEARSEED', description: 'HEAR SEED', hazmat: 'N', un: '' },
  { code: 'HIPRO', description: 'HIPRO', hazmat: 'N', un: '' },
  { code: 'HIPROSOYM', description: 'HI PRO SOYMEAL', hazmat: 'N', un: '' },
  { code: 'HOMINY', description: 'HOMINY', hazmat: 'N', un: '' },
  { code: 'HORSE', description: 'HORSE FEED', hazmat: 'N', un: '' },
  {
    code: 'HORSEEQP',
    description: 'HORSE SHOW EQUIPMENT',
    hazmat: 'N',
    un: '',
  },
  { code: 'HOUACTINI', description: 'HOU-ACTINITE', hazmat: 'N', un: '' },
  { code: 'HOURLYWOR', description: 'HOURLY WORK', hazmat: 'N', un: '' },
  { code: 'HP300', description: 'HP 300 BULK', hazmat: 'N', un: '' },
  { code: 'HULLS', description: 'HULLS', hazmat: 'N', un: '' },
  { code: 'HUMATE', description: 'HUMATE', hazmat: 'N', un: '' },
  {
    code: 'HYDCHIFEA',
    description: 'HYDRO CHICKEN FEATHER MEAL',
    hazmat: 'N',
    un: '',
  },
  { code: 'HYDHUMDGA', description: 'HYDRA HUME DGA', hazmat: 'N', un: '' },
  { code: 'HYDRAHUME', description: 'HYDRA HUME ORE', hazmat: 'N', un: '' },
  {
    code: 'INDOVEGRA',
    description: 'INDIANA OVERSIZED GRAVEL 2-3 IN',
    hazmat: 'N',
    un: '',
  },
  { code: 'INEDIBLE', description: 'LOW GRADE INEDIBLE', hazmat: 'N', un: '' },
  { code: 'INSULATED', description: 'INSULATED PANELS', hazmat: 'N', un: '' },
  { code: 'IRONORE', description: 'IRON ORE', hazmat: 'N', un: '' },
  { code: 'JETTBLACK', description: 'Jett Black', hazmat: 'N', un: '' },
  { code: 'KAOLIN', description: 'KAOLIN', hazmat: 'N', un: '' },
  { code: 'KCLWHITES', description: 'KCL-WHITE SOLUBLE', hazmat: 'N', un: '' },
  {
    code: 'KENGROCOV',
    description: 'KENLITE GROUND COVER 1.5X3/4 ITEM# 9234',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'KENLITE',
    description: 'ITEM 3444- 3/4" X #4 KENLITE',
    hazmat: 'N',
    un: '',
  },
  { code: 'KIBREG', description: 'KIBBLE REGRIND', hazmat: 'N', un: '' },
  {
    code: 'KOSHERVEG',
    description: 'KOSHER VEGETABLE OIL',
    hazmat: 'N',
    un: '',
  },
  { code: 'LAMB', description: 'LAMB', hazmat: 'N', un: '' },
  { code: 'LAMBMEAL', description: 'LAMB MEAL', hazmat: 'N', un: '' },
  { code: 'LARD', description: 'LARD', hazmat: 'N', un: '' },
  { code: 'LAVAROCK', description: 'LAVA ROCK', hazmat: 'N', un: '' },
  { code: 'LENTELS', description: 'LENTELS', hazmat: 'N', un: '' },
  {
    code: 'LGPINEBAN',
    description: 'LARGE PINE BARK NUGGETS- 100YDS',
    hazmat: 'N',
    un: '',
  },
  { code: 'LIME', description: 'LIME', hazmat: 'N', un: '' },
  { code: 'LIMESTONE', description: 'LIMESTONE', hazmat: 'N', un: '' },
  { code: 'LINSEEDME', description: 'LINSEED MEAL', hazmat: 'N', un: '' },
  {
    code: 'LIQSUGSUC',
    description: 'LIQUID SUGAR SUCROSE',
    hazmat: 'N',
    un: '',
  },
  { code: 'LNDSCMAT', description: 'LANDSCAPE MATERIAL', hazmat: 'N', un: '' },
  {
    code: 'LOOSE',
    description: 'LOOSE COTTON SEED HULLS',
    hazmat: 'N',
    un: '',
  },
  { code: 'LOOSEHULL', description: 'LOOSE HULLS', hazmat: 'N', un: '' },
  { code: 'LOOSESOYH', description: 'LOOSE SOY HULLS', hazmat: 'N', un: '' },
  { code: 'LOPRO', description: 'LO PRO', hazmat: 'N', un: '' },
  { code: 'LUMBER', description: 'LUMBER', hazmat: 'N', un: '' },
  { code: 'LYSINEHCL', description: 'Lysine HCL', hazmat: 'N', un: '' },
  { code: 'MAG', description: 'MAG', hazmat: 'N', un: '' },
  { code: 'MAGNAPALM', description: 'MAGNA PALM FAT', hazmat: 'N', un: '' },
  { code: 'MAGOX', description: 'MAGOX', hazmat: 'N', un: '' },
  { code: 'MALTBARLE', description: 'MALT BARLEY', hazmat: 'N', un: '' },
  { code: 'MAP', description: 'MAP', hazmat: 'N', un: '' },
  { code: 'MARBLE', description: 'MARBLE CHIPS', hazmat: 'N', un: '' },
  { code: 'MEATBONEM', description: 'MEAT & BONE MEAL', hazmat: 'N', un: '' },
  { code: 'MEATMEAL', description: 'MEAT MEAL', hazmat: 'N', un: '' },
  { code: 'MEGALAC', description: 'MEGALAC', hazmat: 'N', un: '' },
  { code: 'MELITE', description: 'MELITE', hazmat: 'N', un: '' },
  { code: 'MERAMEC', description: 'MERAMEC SP B', hazmat: 'N', un: '' },
  { code: 'MERAMEC58', description: 'MERAMEC 5/8', hazmat: 'N', un: '' },
  { code: 'MERAMECC', description: 'MERAMEC C', hazmat: 'N', un: '' },
  { code: 'METAATEIN', description: 'METAATEIN', hazmat: 'N', un: '' },
  { code: 'MICRO', description: 'MICRO', hazmat: 'N', un: '' },
  {
    code: 'MICROHUME',
    description: 'MICROHUME FERTILIZER',
    hazmat: 'N',
    un: '',
  },
  { code: 'MICROLITE', description: 'MICROLITE', hazmat: 'N', un: '' },
  { code: 'MICROPRIL', description: 'MICRO PRILLED UREA', hazmat: 'N', un: '' },
  { code: 'MICROTREN', description: 'Micro Trenching', hazmat: 'N', un: '' },
  { code: 'MIDDPELLE', description: 'MIDD PELLETS', hazmat: 'N', un: '' },
  { code: 'MIDDS', description: 'WHEAT MIDDS', hazmat: 'N', un: '' },
  { code: 'MIDGRADE', description: 'MID GRADE', hazmat: 'N', un: '' },
  { code: 'MILLET', description: 'MILLET', hazmat: 'N', un: '' },
  { code: 'MILLFEED', description: 'MILL FEED', hazmat: 'N', un: '' },
  { code: 'MILLRUN', description: 'MILL RUN', hazmat: 'N', un: '' },
  { code: 'MILO', description: 'MILO', hazmat: 'N', un: '' },
  { code: 'MINAD', description: 'MINAD', hazmat: 'N', un: '' },
  { code: 'MINERALS', description: 'MINERALS', hazmat: 'N', un: '' },
  {
    code: 'MISCBAGS',
    description: 'MISCELLANEOUS BAGS PALLETIZED',
    hazmat: 'N',
    un: '',
  },
  { code: 'MISCMERCH', description: 'MISC MERCHANDISE', hazmat: 'N', un: '' },
  {
    code: 'MISUNDGRO',
    description: 'MISCELLANEOUS UNDERGROUND',
    hazmat: 'N',
    un: '',
  },
  { code: 'MIXEDLD', description: 'MIXED PRODUCT', hazmat: 'N', un: '' },
  { code: 'MONOCAL', description: 'MONO CAL', hazmat: 'N', un: '' },
  { code: 'MONODICAL', description: 'MONO DICAL', hazmat: 'N', un: '' },
  { code: 'MSCPROD', description: 'MSC PRODUCT', hazmat: 'N', un: '' },
  { code: 'MULCH', description: 'MULCH', hazmat: 'N', un: '' },
  {
    code: 'NATURALLY',
    description: 'NATURALLY STABLIZIED CHICKEN MEAL',
    hazmat: 'N',
    un: '',
  },
  { code: 'NEXFOS', description: 'NEXFOS', hazmat: 'N', un: '' },
  { code: 'NGMODRUM', description: 'NGMO DRUMS', hazmat: 'N', un: '' },
  { code: 'NKS', description: 'NKS', hazmat: 'N', un: '' },
  { code: 'NOLOAD', description: 'NO LOAD', hazmat: 'N', un: '' },
  { code: 'NONGMO', description: 'NON GMO', hazmat: 'N', un: '' },
  { code: 'NONGMOSM', description: 'NON GMO SOYMEAL', hazmat: 'N', un: '' },
  { code: 'NONGMOSOY', description: 'NON GMO BOYBEANS', hazmat: 'N', un: '' },
  { code: 'NS700', description: 'NS700', hazmat: 'N', un: '' },
  {
    code: 'NURISOL',
    description: 'NURISOL, FEED INGREDIENT',
    hazmat: 'N',
    un: '',
  },
  { code: 'NURSEBARK', description: 'Nursey Bark', hazmat: 'N', un: '' },
  { code: 'OATGROATS', description: 'OAT GROATS', hazmat: 'N', un: '' },
  { code: 'OATHULLS', description: 'OAT HULLS', hazmat: 'N', un: '' },
  { code: 'OATMEAL', description: 'OATMEAL', hazmat: 'N', un: '' },
  { code: 'OATMEALPE', description: 'OATMEAL PELLETS', hazmat: 'N', un: '' },
  { code: 'OATS', description: 'OATS', hazmat: 'N', un: '' },
  { code: 'OILDRI', description: 'OIL-DRI', hazmat: 'N', un: '' },
  { code: 'OILDRY', description: 'OILDRY', hazmat: 'N', un: '' },
  { code: 'ONIONS', description: 'ONIONS', hazmat: 'N', un: '' },
  {
    code: 'ORA2PPF',
    description: 'ORA-2/PPF LACM W/ MIXED TOCOPHEROLS',
    hazmat: 'N',
    un: '',
  },
  { code: 'ORGANIC', description: 'ORGANIC', hazmat: 'N', un: '' },
  {
    code: 'ORGANICAL',
    description: 'ORGANIC ALFALFA PELLETS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ORGANICCA',
    description: 'ORGANIC CANOLA MEAL',
    hazmat: 'N',
    un: '',
  },
  { code: 'ORGANICDD', description: 'ORGANIC DDG', hazmat: 'N', un: '' },
  { code: 'ORGANICOA', description: 'ORANGIC OATS', hazmat: 'N', un: '' },
  {
    code: 'ORGANICPE',
    description: 'ORGANIC PEA PELLETS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ORGANICSU',
    description: 'ORGANIC SUNFLOWER MEAL',
    hazmat: 'N',
    un: '',
  },
  { code: 'ORGANICWH', description: 'ORGANIC WHEAT', hazmat: 'N', un: '' },
  { code: 'ORGANPEAS', description: 'ORGANIC WHOLE PEAS', hazmat: 'N', un: '' },
  { code: 'ORGAOATS', description: 'ORGANIC OATS', hazmat: 'N', un: '' },
  {
    code: 'ORGCASEED',
    description: 'ORGANIC CANOLA SEED',
    hazmat: 'N',
    un: '',
  },
  { code: 'ORGCORN', description: 'ORGANIC CORN', hazmat: 'N', un: '' },
  { code: 'ORGHAY', description: 'HAY, ORGANIC', hazmat: 'N', un: '' },
  { code: 'ORGSOYBEA', description: 'ORGANIC SOYBEANS', hazmat: 'N', un: '' },
  {
    code: 'ORGSOYMEA',
    description: 'ORGANIC SOYBEAN MEAL',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ORGSUSEED',
    description: 'ORGANIC SUNFLOWER SEEDS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ORSUNMEAL',
    description: 'ORGANIC SUNFLOWER MEAL PELLETS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'OSALSUNSE',
    description: 'OVERSIZED AL SUNSET',
    hazmat: 'N',
    un: '',
  },
  { code: 'OYSSHELLS', description: 'OYSTER SHELLS', hazmat: 'N', un: '' },
  { code: 'PACKINGMA', description: 'PACKAGING MATERIAL', hazmat: 'N', un: '' },
  { code: 'PALATANTS', description: 'FOOD FLAVORING', hazmat: 'N', un: '' },
  { code: 'PALMFAT', description: 'PALMFAT', hazmat: 'N', un: '' },
  { code: 'PALMIT80', description: 'PALMIT 80', hazmat: 'N', un: '' },
  { code: 'PARBOILED', description: 'PAR BOILED RICE', hazmat: 'N', un: '' },
  {
    code: 'PASTSULFU',
    description: 'PASTILLE SULFUR NON-HAZARDOUS',
    hazmat: 'N',
    un: '',
  },
  { code: 'PEAFLOUR', description: 'PEA FLOUR', hazmat: 'N', un: '' },
  { code: 'PEAGRAVEL', description: 'PEA GRAVEL', hazmat: 'N', un: '' },
  {
    code: 'PEAHULLGR',
    description: 'PEANUT HULL GRANULES',
    hazmat: 'N',
    un: '',
  },
  { code: 'PEANUT', description: 'PEANUT', hazmat: 'N', un: '' },
  { code: 'PEANUTHU', description: 'PEANUT HULLS', hazmat: 'N', un: '' },
  {
    code: 'PEANUTHUL',
    description: 'PEANUT HULL PELLETS',
    hazmat: 'N',
    un: '',
  },
  { code: 'PEANUTMEA', description: 'PEANUT MEAL', hazmat: 'N', un: '' },
  { code: 'PEAPROTEI', description: 'PEA PROTEIN', hazmat: 'N', un: '' },
  { code: 'PEAS', description: 'PEAS', hazmat: 'N', un: '' },
  { code: 'PECANS', description: 'PECANS', hazmat: 'N', un: '' },
  { code: 'PECANSHEL', description: 'PECAN SHELLS', hazmat: 'N', un: '' },
  { code: 'PELGYPSUM', description: 'PELLETIZED GYPSUM', hazmat: 'N', un: '' },
  { code: 'PELLETS', description: 'PELLETS', hazmat: 'N', un: '' },
  { code: 'PELLIME', description: 'PELLETIZED LIME', hazmat: 'N', un: '' },
  {
    code: 'PENNRED2B',
    description: 'Pennsylvania Red 2B',
    hazmat: 'N',
    un: '',
  },
  { code: 'PERLITE', description: 'PERLITE', hazmat: 'N', un: '' },
  { code: 'PETFOOD', description: 'PET FOOD', hazmat: 'N', un: '' },
  { code: 'PETFOODFI', description: 'PET FOOD FINES', hazmat: 'N', un: '' },
  { code: 'PETMEAL', description: 'PET MEAL', hazmat: 'N', un: '' },
  { code: 'PHOSPHATE', description: 'PHOSPHATE', hazmat: 'N', un: '' },
  { code: 'PHP', description: 'PHP', hazmat: 'N', un: '' },
  { code: 'PIPE', description: 'MISC PIPE', hazmat: 'N', un: '' },
  { code: 'PIPINGSPO', description: 'PIPING SPOOLS', hazmat: 'N', un: '' },
  { code: 'PLASTIC', description: 'PLASTICS', hazmat: 'N', un: '' },
  { code: 'PLYWOOD', description: 'PLYWOOD', hazmat: 'N', un: '' },
  { code: 'POLYON42', description: 'POLYON 42', hazmat: 'N', un: '' },
  { code: 'POLYSULPH', description: 'POLYSULPHATE', hazmat: 'N', un: '' },
  { code: 'POPCORN', description: 'POPCORN', hazmat: 'N', un: '' },
  { code: 'PORKBEEFB', description: 'PORK BEEF BLEND', hazmat: 'N', un: '' },
  { code: 'PORKBLOOD', description: 'PORK BLOOD', hazmat: 'N', un: '' },
  { code: 'PORKGREAS', description: 'PORK GREASE', hazmat: 'N', un: '' },
  { code: 'PORKMEAL', description: 'PORK MEAL', hazmat: 'N', un: '' },
  { code: 'PORKMEATB', description: 'PORK MEAT & BONE', hazmat: 'N', un: '' },
  { code: 'PORTVALVE', description: 'PORT VALVES', hazmat: 'N', un: '' },
  { code: 'POTASH', description: 'POTASH', hazmat: 'N', un: '' },
  { code: 'POTASSCHL', description: 'POTASSIUM CHLORIDE', hazmat: 'N', un: '' },
  { code: 'POTASSIUM', description: 'POTASSIUM', hazmat: 'N', un: '' },
  { code: 'POTATO', description: 'POTATO PELLETS', hazmat: 'N', un: '' },
  { code: 'POTATOES', description: 'POTATOES', hazmat: 'N', un: '' },
  { code: 'POTATOFLA', description: 'POTATO FLAKES', hazmat: 'N', un: '' },
  { code: 'POULTRY', description: 'POULTRY', hazmat: 'N', un: '' },
  { code: 'POULTRYBL', description: 'POULTRY BLOOD MEAL', hazmat: 'N', un: '' },
  { code: 'POULTRYBY', description: 'POULTRY BY PRODUCT', hazmat: 'N', un: '' },
  { code: 'POULTRYFA', description: 'POULTRY FAT', hazmat: 'N', un: '' },
  { code: 'POULTRYME', description: 'POULTRY MEAL', hazmat: 'N', un: '' },
  { code: 'PREBLEND', description: 'PREBLEND/PREMIX', hazmat: 'N', un: '' },
  {
    code: 'PREDRCHI',
    description: 'PREMIUM DRIED CHICKEN',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PREMBUNKS',
    description: 'PREMIUM BUNKER SAND',
    hazmat: 'N',
    un: '',
  },
  { code: 'PRILLED', description: 'PRILLED UREA', hazmat: 'N', un: '' },
  {
    code: 'PROANGLEG',
    description: 'PRO ANGLE GOLF SAND',
    hazmat: 'N',
    un: '',
  },
  { code: 'PROCCOAL', description: 'PROCESSED COAL', hazmat: 'N', un: '' },
  { code: 'PROMOLAS', description: 'PROMOLAS', hazmat: 'N', un: '' },
  { code: 'PROTEIN', description: 'PROTEIN', hazmat: 'N', un: '' },
  {
    code: 'PROVAAL2A',
    description: 'PROVAAL 2 ADVANTAGE',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PROVISOY',
    description: 'Provisoy - Extru Soybean',
    hazmat: 'N',
    un: '',
  },
  { code: 'PUMICE', description: 'PUMICE', hazmat: 'N', un: '' },
  { code: 'PURAPHOS', description: 'PURAPHOS', hazmat: 'N', un: '' },
  { code: 'RAILS', description: 'RAILS', hazmat: 'N', un: '' },
  { code: 'RAINB2X1', description: 'RAINBOW 2X1', hazmat: 'N', un: '' },
  { code: 'RAINBOW', description: 'RAINBOW 5-15-30', hazmat: 'N', un: '' },
  { code: 'RAINBOW78', description: 'RAINBOW 7/8', hazmat: 'N', un: '' },
  { code: 'RAINBOWLA', description: 'RAINBOW LARGE 2X5', hazmat: 'N', un: '' },
  { code: 'RAPESEED', description: 'RAPE SEED/ CANOLA', hazmat: 'N', un: '' },
  { code: 'REDDOG', description: 'RED DOG', hazmat: 'N', un: '' },
  { code: 'REDSUNLAV', description: 'RED SUNSET LAVA', hazmat: 'N', un: '' },
  { code: 'REJECTS', description: 'REJECTS', hazmat: 'N', un: '' },
  { code: 'RICE', description: 'RICE', hazmat: 'N', un: '' },
  { code: 'RICEDUST', description: 'RICE DUST', hazmat: 'N', un: '' },
  { code: 'RICEHULLS', description: 'RICE HULLS', hazmat: 'N', un: '' },
  { code: 'RICEMILLF', description: 'RICE MILL FEED', hazmat: 'N', un: '' },
  { code: 'RIVERROCK', description: 'RIVER ROCK', hazmat: 'N', un: '' },
  { code: 'ROAD SALT', description: 'ROAD SALT', hazmat: 'N', un: '' },
  { code: 'ROADBASE', description: 'ROAD BASE', hazmat: 'N', un: '' },
  { code: 'ROASTEDSO', description: 'ROASTED SOYBEANS', hazmat: 'N', un: '' },
  { code: 'ROCKADDER', description: 'Rock Adder', hazmat: 'N', un: '' },
  { code: 'ROCKSALT', description: 'ROCK SALT', hazmat: 'N', un: '' },
  { code: 'ROLLEDCOR', description: 'ROLLED CORN', hazmat: 'N', un: '' },
  { code: 'ROOFINGGR', description: 'ROOFING GRANULES', hazmat: 'N', un: '' },
  { code: 'ROUGHRICE', description: 'ROUGH RICE', hazmat: 'N', un: '' },
  {
    code: 'ROYGEORGE',
    description: 'ROYAL GORGE R01-1420',
    hazmat: 'N',
    un: '',
  },
  { code: 'RR1', description: 'RR1', hazmat: 'N', un: '' },
  {
    code: 'RUMENBUFF',
    description: 'RUMEN BUFFER BULK PALLET',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'RUSTYROSE',
    description: 'RUSTY ROSE- CLEAN LANDSCAPE RED 1"',
    hazmat: 'N',
    un: '',
  },
  { code: 'RYE', description: 'RYE', hazmat: 'N', un: '' },
  { code: 'SAFF', description: 'SAFFLOWER', hazmat: 'N', un: '' },
  { code: 'SALMONMEA', description: 'SALMON MEAL', hazmat: 'N', un: '' },
  { code: 'SALT', description: 'SALT', hazmat: 'N', un: '' },
  { code: 'SAND', description: 'SAND', hazmat: 'N', un: '' },
  { code: 'SAPONITE', description: 'SAPONITE', hazmat: 'N', un: '' },
  { code: 'SCARB', description: 'S CARB', hazmat: 'N', un: '' },
  { code: 'SCREENING', description: 'SCREENINGS', hazmat: 'N', un: '' },
  { code: 'SEED', description: 'SEED', hazmat: 'N', un: '' },
  { code: 'SESAME', description: 'SESAME SEED', hazmat: 'N', un: '' },
  {
    code: 'SHELLBONE',
    description: 'SHELL & BONE BUILDER',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SHOOTSTAR',
    description: 'SHOOTING STAR 1 1/2 #8580',
    hazmat: 'N',
    un: '',
  },
  { code: 'SLAG', description: 'SLAG, UNSPECIFIED', hazmat: 'N', un: '' },
  { code: 'SLTCHIMED', description: 'SLATE CHIPS MEDIUM', hazmat: 'N', un: '' },
  { code: 'SOAP', description: 'SOAP, LIQUID', hazmat: 'N', un: '' },
  { code: 'SODAASH', description: 'SODA ASH', hazmat: 'N', un: '' },
  { code: 'SODIUM', description: 'SODIUM BI-CARB', hazmat: 'N', un: '' },
  {
    code: 'SODIUMSES',
    description: 'SODIUM SESQUIC CARBONATE',
    hazmat: 'N',
    un: '',
  },
  { code: 'SOFTREDWH', description: 'SOFT RED WHEAT', hazmat: 'N', un: '' },
  { code: 'SOFTWHITE', description: 'SOFT WHITE WHEAT', hazmat: 'N', un: '' },
  { code: 'SOP', description: 'SOP', hazmat: 'N', un: '' },
  { code: 'SORGHUM', description: 'SORGHUM', hazmat: 'N', un: '' },
  { code: 'SOY', description: 'SOY', hazmat: 'N', un: '' },
  { code: 'SOYBEANBL', description: 'SOYBEAN BLEND', hazmat: 'N', un: '' },
  { code: 'SOYBEANGE', description: 'SOYBEAN GERM MEAL', hazmat: 'N', un: '' },
  {
    code: 'SOYBEANHP',
    description: 'SOYBEAN HULL PELLETS',
    hazmat: 'N',
    un: '',
  },
  { code: 'SOYBEANHU', description: 'SOYBEAN HULLS', hazmat: 'N', un: '' },
  { code: 'SOYBEANME', description: 'SOYBEAN MEAL', hazmat: 'N', un: '' },
  { code: 'SOYBEANS', description: 'SOYBEANS', hazmat: 'N', un: '' },
  {
    code: 'SOYDEULLE',
    description: 'SOYBEAN MEAL DEHULLED',
    hazmat: 'N',
    un: '',
  },
  { code: 'SOYHULLPE', description: 'SOYHULL PELLETS', hazmat: 'N', un: '' },
  { code: 'SOYMEAL', description: 'SOYMEAL', hazmat: 'N', un: '' },
  { code: 'SOYOIL', description: 'SOY OIL', hazmat: 'N', un: '' },
  { code: 'SOYPLUS', description: 'SOY PLUS', hazmat: 'N', un: '' },
  { code: 'SPP', description: 'SPP', hazmat: 'N', un: '' },
  { code: 'SQ810', description: 'SQ810', hazmat: 'N', un: '' },
  {
    code: 'SRMFREEBE',
    description: 'SRM FREE BEEF MEAT AND BONE',
    hazmat: 'N',
    un: '',
  },
  { code: 'SRO', description: 'STEAM ROLLED OATS', hazmat: 'N', un: '' },
  { code: 'STABILIZE', description: 'STABILIZED BRAN', hazmat: 'N', un: '' },
  { code: 'STEEL', description: 'STRUCTURAL STEEL', hazmat: 'N', un: '' },
  { code: 'STEELBEAM', description: 'STEEL BEAMS', hazmat: 'N', un: '' },
  { code: 'STEELCOIL', description: 'STEEL COIL', hazmat: 'N', un: '' },
  { code: 'STEELPILI', description: 'STEEL PILING', hazmat: 'N', un: '' },
  { code: 'STEELPIPE', description: 'STEEL PIPE', hazmat: 'N', un: '' },
  { code: 'STEELPLAT', description: 'STEEL PLATE', hazmat: 'N', un: '' },
  { code: 'STONE', description: 'STONE', hazmat: 'N', un: '' },
  { code: 'SUGAR', description: 'SUGAR', hazmat: 'N', un: '' },
  { code: 'SULFATE', description: 'SULFATE', hazmat: 'N', un: '' },
  {
    code: 'SULFURPAS',
    description: 'PASTILLE SULFUR NON-HAZARDOUS',
    hazmat: 'N',
    un: '',
  },
  { code: 'SULFURPLU', description: 'SULFUR PLUS', hazmat: 'N', un: '' },
  { code: 'SULPHUR', description: 'SULPHUR', hazmat: 'N', un: '' },
  { code: 'SUNFLMEAL', description: 'SUNFLOWER MEAL', hazmat: 'N', un: '' },
  { code: 'SUNFLOWER', description: 'SUNFLOWER SEED', hazmat: 'N', un: '' },
  { code: 'SUPERSACK', description: 'SUPER SACKS', hazmat: 'N', un: '' },
  { code: 'SUREPRO', description: 'SURE PRO', hazmat: 'N', un: '' },
  { code: 'SWEET', description: 'SWEET POTATOES', hazmat: 'N', un: '' },
  {
    code: 'SWEETPOTA',
    description: 'SWEET POTATO PELLETS',
    hazmat: 'N',
    un: '',
  },
  { code: 'TAILINGS', description: 'TAILINGS', hazmat: 'N', un: '' },
  { code: 'TALLOW', description: 'TALLOW', hazmat: 'N', un: '' },
  {
    code: 'TAPIOCA',
    description: 'Tapioca Starch, Powdered',
    hazmat: 'N',
    un: '',
  },
  { code: 'TIRECHIPS', description: 'TIRE CHIPS', hazmat: 'N', un: '' },
  { code: 'TIREFLUFF', description: 'TIRE FLUFF', hazmat: 'N', un: '' },
  { code: 'TIRES', description: 'RUBBER TIRES', hazmat: 'N', un: '' },
  { code: 'TIRESHRED', description: 'TIRE SHRED', hazmat: 'N', un: '' },
  { code: 'TIREWIRE', description: 'TIRE WIRE', hazmat: 'N', un: '' },
  { code: 'TOMATOPOM', description: 'TOMATO POMACE', hazmat: 'N', un: '' },
  { code: 'TONU', description: 'TRUCK ORDERED NOT USED', hazmat: 'N', un: '' },
  { code: 'TOPSOIL', description: 'TOP SOIL', hazmat: 'N', un: '' },
  { code: 'TOTEDFISH', description: 'TOTED FISH OIL', hazmat: 'N', un: '' },
  {
    code: 'TRIOGRANP',
    description: 'TRIO GRANULAR POTASH',
    hazmat: 'N',
    un: '',
  },
  { code: 'TRIPLE', description: 'TRIPLE', hazmat: 'N', un: '' },
  {
    code: 'TRIPLETRU',
    description: 'TRIPLE TRUST 24-16-5 COMPRESS TUB 200#',
    hazmat: 'N',
    un: '',
  },
  { code: 'TRITICALE', description: 'TRITICALE SEED', hazmat: 'N', un: '' },
  { code: 'TRONACARB', description: 'TRONA CARB', hazmat: 'N', un: '' },
  { code: 'TROPICOTE', description: 'TROPICOTE', hazmat: 'N', un: '' },
  { code: 'TRUI', description: 'TRUI', hazmat: 'N', un: '' },
  { code: 'TSP', description: 'TSP', hazmat: 'N', un: '' },
  { code: 'TUBING', description: 'TUBING', hazmat: 'N', un: '' },
  { code: 'TURKEYBY', description: 'TURKEY BY', hazmat: 'N', un: '' },
  { code: 'TURKEYMEA', description: 'TURKEY MEAL', hazmat: 'N', un: '' },
  { code: 'TURKEYOFF', description: 'TURKEY OFFAL', hazmat: 'N', un: '' },
  { code: 'UNDERGROU', description: 'Underground Work', hazmat: 'N', un: '' },
  { code: 'UREA', description: 'UREA', hazmat: 'N', un: '' },
  { code: 'VANTRAILE', description: 'VAN TRAILER', hazmat: 'N', un: '' },
  { code: 'VAULTPLAC', description: 'Vault Placement', hazmat: 'N', un: '' },
  { code: 'VDOGPRE', description: 'V-DOG PREBLEND 2020', hazmat: 'N', un: '' },
  { code: 'VINYL', description: 'VINYL', hazmat: 'N', un: '' },
  { code: 'VITAMINS', description: 'VITAMINS', hazmat: 'N', un: '' },
  { code: 'WASHHOP', description: 'HOPPER WASHOUT', hazmat: 'N', un: '' },
  { code: 'WCHIP', description: 'WOOD CHIPS', hazmat: 'N', un: '' },
  { code: 'WETDDGS', description: 'WET DDGs', hazmat: 'N', un: '' },
  { code: 'WHEAT', description: 'WHEAT', hazmat: 'N', un: '' },
  { code: 'WHEATMIDD', description: 'WHEAT MIDDS', hazmat: 'N', un: '' },
  { code: 'WHEY', description: 'WHEY', hazmat: 'N', un: '' },
  {
    code: 'WHITECORN',
    description: 'FOOD GRADE WHITE CORN',
    hazmat: 'N',
    un: '',
  },
  { code: 'WHITERICE', description: 'WHITE RICE', hazmat: 'N', un: '' },
  { code: 'WHOLECOTT', description: 'WHOLE COTTON SEED', hazmat: 'N', un: '' },
  { code: 'WICOBBLES', description: 'WI COBBLES- 18-24"', hazmat: 'N', un: '' },
  { code: 'WINCHTRUC', description: 'WINCH TRUCK', hazmat: 'N', un: '' },
  {
    code: 'WIUNSCOBB',
    description: 'WI UNSORTED COBBLE STONES 3-9"',
    hazmat: 'N',
    un: '',
  },
  { code: 'YEAST', description: 'YEAST', hazmat: 'N', un: '' },
  { code: 'YELLOWCOR', description: 'YELLOW CORN', hazmat: 'N', un: '' },
  { code: 'YELLOWPEA', description: 'YELLOW PEAS', hazmat: 'N', un: '' },
  {
    code: 'YELMUSSEE',
    description: 'YELLOW MUSTARD SEEDS',
    hazmat: 'N',
    un: '',
  },
  { code: 'ZINCSUL', description: 'ZINC SULFATE', hazmat: 'N', un: '' },
];

// Qualifiers PT books on synced stop references that the shared McLeod list lacks. PT has no qualifier
// export yet, so helpers.ts serves the shared list plus these (P8 is on 572 PT stop references).
export const ptExtraReferenceNumberOptions: McleodReferenceNumberOption[] = [
  { description: 'Pickup Reference Number', code: 'P8' },
];
